export const GLOBAL_GETTERS = {
  GET_BASE_TOKEN: 'tokens/getBaseToken',
  GET_BASE_TOKEN_ADDRESS: 'tokens/getBaseTokenAddress',
  GET_NATIVE_TOKEN: 'tokens/getNativeToken',
  GET_ALL_PORTFOLIOS_PAIRS: 'portfolios/getAllPairs',
};
